export default "__VITE_ASSET__BFq1MurN__"